import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import ApiUrl from "../../config/app-config";

const baseURL = ApiUrl();
const pageName = "자주 하는 질문";

const AgreePage = (props) => {
  const headerUi = {
    goback: false,
    closeAll: true,
  };
  useEffect(() => {
    props.onPageName(pageName);
    props.onHeaderUi(headerUi);
  }, []);

  /**TESTDetail 받아오는 부분 */
  const [data, setData] = useState();
  async function getData() {
    props.onIsLoading(true);
    try {
      //응답 성공
      const response = await axios.get(`${baseURL}/v1/faq`, {
        params: {
          listSize: 50,
          totalListCount: 4,
          message: "Success",
          currentPageIndex: 1,
        },
      });
      const success = response.data;
      const result = success.result;
      props.onIsLoading(false);
      setData(result);
    } catch (error) {
      //응답 실패
      props.onIsLoading(false);
      props.onError(true);
      console.error(error);
    }
  }
  useEffect(() => {
    getData();
  }, []);
  const contentId = useParams();
  const faqDetailData =
    data && data.filter((item) => String(item.id) === String(contentId.id));

  return (
    <>
      {faqDetailData &&
        faqDetailData.map((faq) => {
          return (
            <div className="container faq_detail_wrap">
              <h3>
                [{faq.faqType}] {faq.question}
              </h3>
              <p className="font-content">{faq.answer}</p>
            </div>
          );
        })}
    </>
  );
};
export default AgreePage;
